export default "__VITE_ASSET__D2OXg593__"